import { useState, useEffect } from 'react';

import * as certificateServices from '../../../../../services/certificateServices.js';
import css from './AddNewCertificate.module.css';

function AddNewCertificate({ data, onAdd, toggleModal, func }) {
    const [message, setMessage] = useState({ message: '' });
    const [pendingCertificates, setPendingCertificates] = useState([]);
    const [filteredPendingCertificates, setFilteredPendingCertificates] = useState([]);

    let template = {};

    const [newData, setNewData] = useState(template);

    useEffect(() => {
        certificateServices
            .getOption('pendingCertificates')
            .then((res) => {
                setPendingCertificates(res.data);
                setFilteredPendingCertificates(res.data)
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const handleChange = (e) => {
        const { id, value } = e.target;

        setNewData((state) => ({
            ...state,
            [id]: value,
        }));
        // if (e.target.id === 'programId') {
        //     setNewData((state) => ({
        //         ...state,
        //         courseTitle: programList.filter((x) => x.programId === Number(e.target.value))[0].programTitle,
        //         courseTypeId: programList.filter((x) => x.programId === Number(e.target.value))[0].courseTypeId,
        //     }));
        // }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (func === 'edit') {
        //     let updateData = newData;
        //     // console.log(updateData);
        //     let type = programList.filter((a) => {
        //         // console.log(`${+a.programId} === ${newData.programId} => ${a.courseTypeId}`);
        //         return +a.programId === +newData.programId;
        //     })[0].courseTypeId;
        //     // console.log(type);
        //     updateData.courseTypeId = Number(type);
        //     courseServices
        //         .edit(updateData)
        //         .then((result) => {
        //             console.log(result);
        //             setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
        //             onAdd(newData);
        //             return true;
        //         })
        //         .catch((error) => {
        //             console.log(message); //check why colors are not changing
        //             console.log(error);
        //         });
        // } else {
        //     courseServices
        //         .create(newData)
        //         .then((result) => {
        //             console.log(result);
        //             setNewData((prevDate) => template);
        //             setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
        //             onAdd(newData);
        //             return true;
        //         })
        //         .catch((err) => {
        //             // console.log(err);
        //             setMessage((state) => ({ message: 'Sorry, something went wrong!', color: 'red' })); //check why colors are not changing
        //             console.log(message); //check why colors are not changing
        //             return false;
        //         });
        // }
    };

    const onAddStay = (e) => {
        e.preventDefault();

        // if (newData.programId) {
        //     handleSubmit(e);
        //     setNewData((state) => template);
        // } else {
        //     setMessage((state) => ({ message: 'Please select program', color: 'red' })); //check why colors are not changing
        // }
    };

    const onAddClose = (e) => {
        e.preventDefault();

        // if (newData.programId) {
        //     let pass = handleSubmit(e);
        //     if (pass) {
        //         toggleModal();
        //     }
        // } else {
        //     setMessage((state) => ({ message: 'Please select program', color: 'red' })); //check why colors are not changing
        // }
    };

    const getUniqueByKey = (array, key) => {
        return array.filter((obj, index, self) =>
            index === self.findIndex((o) => o[key] === obj[key])
          );
    }

    const filterPending = (e) => {
        console.log("Here ...");
        
        console.log(e.target.value);
        
    }

    return (
        <div className={css.backdrop}>
            <div className={css.modal}>
                <form className={css.form}>
                    <div className={css.formData}>

                        <label htmlFor="courseId"></label>
                        <select id="courseId" value={1} onChange={filterPending}>
                            {getUniqueByKey(pendingCertificates, "courseId").map((x) => (
                                <option key={x.courseId} id={x.courseId}>
                                    #{x.courseNo} - {x.courseTitle}
                                </option>
                            ))}
                        </select>

                        <label className={css.label} htmlFor="certificateId">
                            Course No:{' '}
                        </label>
                        {func === 'edit' ? (
                            <input
                                className={css.input}
                                type="text"
                                id="certificateId"
                                value={newData.courseNo}
                                onChange={handleChange}
                                disabled
                            />
                        ) : (
                            <input className={css.input} type="text" id="courseNo" value={newData.courseNo} onChange={handleChange} />
                        )}

                        {/*<label htmlFor="programId">Program: </label>
                        <select id="programId" onChange={handleChange} className={css.input} value={newData.programId} required>
                            <option key={'na'} value={0}>
                                Select program ...
                            </option>
                            {programList.map((x) => (
                                <option key={x.programId} value={x.programId}>
                                    {x.programTitle}
                                </option>
                            ))}
                        </select>

                        <label className={css.label} htmlFor="courseTitle">
                            Course Title:{' '}
                        </label>
                        <input className={css.input} type="text" id="courseTitle" value={newData.courseTitle} onChange={handleChange} />

                        <label className={css.label} htmlFor="courseStart">
                            Start:{' '}
                        </label>
                        <input
                            className={css.input}
                            type="date"
                            id="courseStart"
                            value={newData.courseStart}
                            onChange={handleChange}
                            dataDateFormat="DD MMM YYYY"
                        />

                        <label className={css.label} htmlFor="courseEnd">
                            End:{' '}
                        </label>
                        <input className={css.input} type="date" id="courseEnd" value={newData.courseEnd} onChange={handleChange} />
                        <label className={css.label} htmlFor="courseDuration">
                            Duration:{' '}
                        </label>
                        <input
                            className={css.input}
                            type="number"
                            id="courseDuration"
                            value={newData.courseDuration}
                            onChange={handleChange}
                        />
                        <label className={css.label} htmlFor="courseLocation">
                            Location:{' '}
                        </label>
                        <input
                            className={css.input}
                            type="text"
                            id="courseLocation"
                            value={newData.courseLocation}
                            onChange={handleChange}
                        />

                        <label htmlFor="courseStatusName">Status: </label>
                        <select id="courseStatusName" onChange={handleChange} className={css.input} value={newData.courseStatusName}>
                            <option value="Planned">Planned</option>
                            <option value="In progress">In progress</option>
                            <option value="Closed">Closed</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Acquisition">Acquisition</option>
                        </select> */}
                    </div>

                    {/* <div>
                        <label htmlFor="courseComments">Comments</label>
                        <textarea id="courseComments" className={css.textarea} rows="32" onChange={handleChange}>
                            {newData.courseComments}
                        </textarea>
                    </div> */}
                    <div className={css.formButtons}>
                        <div className={css.submitButtons}>
                            {func === 'edit' ? (
                                <>
                                    <button className={css.button} onClick={onAddClose}>
                                        Edit Certificate
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button className={css.button} onClick={onAddStay}>
                                        Add Certificate and stay
                                    </button>
                                    <button className={css.button} onClick={onAddClose}>
                                        Add Certificate and close
                                    </button>
                                </>
                            )}
                        </div>
                        <button onClick={toggleModal} className={`${css.button} ${css.buttonClose}`}>
                            Cancel
                        </button>
                        {/* Check why colors are not changing */}
                        <p className={css[message.color]}>{message.message}</p>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddNewCertificate;
